import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { adminApi } from "../../lib/api";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    adminApi.get("/admin/logs", { params: { limit: 200 } })
      .then((r) => setLogs(r.data))
      .catch(() => setLogs([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    let cancelled = false;
    adminApi.get("/admin/logs", { params: { limit: 200 } })
      .then((r) => { if (!cancelled) setLogs(r.data); })
      .catch(() => { if (!cancelled) setLogs([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="space-y-6" data-testid="admin-logs-page">
      <div className="flex items-end justify-between">
        <div>
          <p className="text-xs uppercase tracking-widest text-cm-ink-soft font-medium">Auditoría</p>
          <h1 className="font-serif text-3xl sm:text-4xl mt-1 tracking-tight">Logs de integración Arcos</h1>
          <p className="text-sm text-cm-ink-soft mt-1">Últimas 200 llamadas a la API de Arco365.</p>
        </div>
        <Button onClick={load} variant="outline" className="border-cm-ink hover:bg-cm-ink hover:text-cm-cream" data-testid="refresh-logs-btn">
          <RefreshCw className="h-4 w-4 mr-2" /> Refrescar
        </Button>
      </div>

      <Card className="bg-white border-cm-border shadow-none overflow-hidden">
        {loading ? (
          <p className="p-8 text-cm-ink-soft text-center">Cargando logs...</p>
        ) : logs.length === 0 ? (
          <p className="p-8 text-cm-ink-soft text-center" data-testid="logs-empty">No hay logs todavía.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="logs-table">
              <thead className="text-left text-xs uppercase tracking-wider text-cm-ink-soft bg-cm-cream-alt/40">
                <tr>
                  <th className="px-4 py-3">Timestamp</th>
                  <th className="px-4 py-3">Método</th>
                  <th className="px-4 py-3">Endpoint</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Duración</th>
                  <th className="px-4 py-3">Modo</th>
                  <th className="px-4 py-3">Error</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-cm-border">
                {logs.map((l, i) => {
                  const isError = l.error || (l.status_code && l.status_code >= 400);
                  return (
                    <tr key={i} className={`hover:bg-cm-cream-alt/30 ${isError ? "bg-cm-red/5" : ""}`}>
                      <td className="px-4 py-2.5 font-mono text-[11px] text-cm-ink-soft whitespace-nowrap">
                        {l.timestamp ? new Date(l.timestamp).toLocaleString("es-CO") : "—"}
                      </td>
                      <td className="px-4 py-2.5 font-mono text-xs">{l.method}</td>
                      <td className="px-4 py-2.5 font-mono text-xs truncate max-w-[200px]">{l.endpoint}</td>
                      <td className="px-4 py-2.5">
                        {l.status_code ? (
                          <Badge variant="outline" className={`font-mono text-xs ${
                            l.status_code < 300 ? "border-green-300 text-green-800 bg-green-50" :
                            l.status_code < 400 ? "border-blue-300 text-blue-800 bg-blue-50" :
                            "border-red-300 text-red-800 bg-red-50"
                          }`}>{l.status_code}</Badge>
                        ) : "—"}
                      </td>
                      <td className="px-4 py-2.5 font-mono text-xs text-cm-ink-soft">{l.duration_ms ?? "—"}ms</td>
                      <td className="px-4 py-2.5">
                        {l.mock ? <Badge variant="outline" className="text-[10px] border-cm-yellow bg-cm-yellow/20">MOCK</Badge>
                                : <Badge variant="outline" className="text-[10px] border-cm-border">LIVE</Badge>}
                      </td>
                      <td className="px-4 py-2.5 text-xs text-cm-red font-mono truncate max-w-[200px]">{l.error || "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
